module.exports = __webpack_public_path__ + "fonts/manrope.c0554e2b.otf";